import * as React from 'react';

const DashIcon = ({fillColor = '#fff'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={8} height={2} fill="none">
    <path
      stroke={fillColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7 1H1"
    />
  </svg>
);

export default DashIcon;
